import React, { useState, useEffect } from 'react';
import { FlashcardArray } from 'react-quizlet-flashcard';
import ComponentTitle from './ComponentTitle';
import DOMPurify from 'dompurify';

interface CPCUFlashCardListProps {
  listId?: string | undefined;
  element?: any | undefined;
}

const CPCUFlashCardList: React.FC<CPCUFlashCardListProps> = props => {
  const [cardArray, setCards] = useState<any[]>([]);
  useEffect(() => {
    const fetchCards = async (): Promise<void> => {
      let data = null;
      if (props.element !== undefined && props.element !== null) {
        data = { elements: props.element };

        // This HTML will be used to display 'click to flip/reveal' on the front of the flashcard
        let cardList: { id: string; frontHTML: string; backHTML: string }[] =
          [];
        data.elements.flashcards?.linkedItems?.forEach((item: any) => {
          let tempCard = {
            id: item.system.id,
            frontHTML: '',
            backHTML: '',
          };
          if (item.elements.front_asset?.value[0]?.url !== undefined) {
            const frontImageHTML = `<img src="${item.elements.front_asset.value[0].url}" alt="Front" style="max-width:100%;padding-top:10px;display:block;margin:auto;" />`;
            tempCard.frontHTML = DOMPurify.sanitize(frontImageHTML);
          } else {
            tempCard.frontHTML = DOMPurify.sanitize(item.elements.front.value);
          }
          if (item.elements.back_asset?.value[0]?.url !== undefined) {
            const backImageHTML = `<img src="${item.elements.back_asset.value[0].url}" alt="Back" style="max-width:100%;padding-top:10px;display:block;margin:auto;" />`;
            tempCard.backHTML = DOMPurify.sanitize(backImageHTML);
          } else {
            tempCard.backHTML = DOMPurify.sanitize(item.elements.back.value);
          }
          cardList.push(tempCard);
        });
        setCards(cardList);
      }
    };
    fetchCards();
  }, [props.listId, props.element]);

  if (cardArray.length === 0) {
    return <div>No flashcards available.</div>;
  }

  return (
    <div
      className="da-panel-primary"
      style={{ width: '600px', justifyContent: 'center', margin: 'auto' }}
    >
      {props.element?.title?.value && (
        <ComponentTitle title={props.element.title.value} />
      )}
      <FlashcardArray
        cards={cardArray}
        controls={cardArray.length > 1}
        showCount={cardArray.length > 1}
        frontContentStyle={{
          paddingTop: '10px',
          boxShadow: '0px',
          textAlign: 'center',
        }}
        backContentStyle={{
          paddingTop: '10px',
          boxShadow: '0px',
          textAlign: 'center',
        }}
        FlashcardArrayStyle={{
          width: '580px',
        }}
      />
    </div>
  );
};
export { CPCUFlashCardList };
